<div class="main-div">
    <div class="wrapper fadeInDown">
        <div class="form-group mb-0">
            <mat-form-field class="absence-form-field">
                <mat-label>Rol Seciniz</mat-label>
                <mat-select [(value)]="selectedRole">
                    <mat-option *ngFor="let role of roles" [value]="role.name">
                        {{role.description}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <button type="button" class="btn btn-primary float-left" (click)="loginWithRole()">Devam</button>
    </div>
</div>
